import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '@sm/intl';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import Answers from './Answers';
const COPY = {
  NumberedQuestionHeading: {
    id: 'buildWithAi.Question.NumberedQuestionHeading',
    defaultMessage: '{number}. {questionHeading}',
    description: '[Type: label][Vis: med] - Question heading but with the question number prepended'
  }
};
/**
 * Renders a generated survey question.
 */
const Question = ({
  question,
  questionNumber
}) => {
  const {
    title
  } = question;
  return _jsxs(_Fragment, {
    children: [_jsx(Box, {
      mb: 3,
      children: _jsx(Typography, {
        variant: "body",
        weight: "medium",
        children: t(COPY.NumberedQuestionHeading, {
          number: questionNumber,
          questionHeading: title
        })
      })
    }), _jsx(Answers, {
      question: question
    })]
  });
};
export default Question;